import * as Types from '../../gql.generated';

import gql from 'graphql-tag';
export type FixedRatesFragmentFragment = (
  { __typename?: 'FixedRates' }
  & Pick<Types.FixedRates, 'participantPerDay' | 'vehiclePerDay' | 'feePerDay' | 'serviceTeamPerDay' | 'workshopPerDay' | 'coldcellPerDay' | 'allowancePerDay' | 'hotelPerNight' | 'compactRentalPerDay' | 'midSizeRentalPerDay' | 'fullSizeRentalPerDay' | 'estateRentalPerDay' | 'minibusRentalPerDay' | 'flightPerRoute' | 'ferryPerParticipant' | 'ferryPerVehicle' | 'useParticipantPerDay' | 'useVehiclePerDay' | 'useFeePerDay' | 'useServiceTeamPerDay' | 'useWorkshopPerDay' | 'useColdcellPerDay' | 'useAllowancePerDay' | 'useHotelPerNight' | 'useCompactRentalPerDay' | 'useMidSizeRentalPerDay' | 'useFullSizeRentalPerDay' | 'useEstateRentalPerDay' | 'useMinibusRentalPerDay' | 'useFlightPerRoute' | 'useFerryPerParticipant' | 'useFerryPerVehicle'>
);
export const FixedRatesFragmentFragmentDoc = gql`
    fragment FixedRatesFragment on FixedRates {
  participantPerDay
  vehiclePerDay
  feePerDay
  serviceTeamPerDay
  workshopPerDay
  coldcellPerDay
  allowancePerDay
  hotelPerNight
  compactRentalPerDay
  midSizeRentalPerDay
  fullSizeRentalPerDay
  estateRentalPerDay
  minibusRentalPerDay
  flightPerRoute
  ferryPerParticipant
  ferryPerVehicle
  useParticipantPerDay
  useVehiclePerDay
  useFeePerDay
  useServiceTeamPerDay
  useWorkshopPerDay
  useColdcellPerDay
  useAllowancePerDay
  useHotelPerNight
  useCompactRentalPerDay
  useMidSizeRentalPerDay
  useFullSizeRentalPerDay
  useEstateRentalPerDay
  useMinibusRentalPerDay
  useFlightPerRoute
  useFerryPerParticipant
  useFerryPerVehicle
}
    `;